<div class="question-answer-text">
  <div class="question">
    <b>{{ question }}</b>
  </div>
  <div class="answer">
    <lhpe-input [control]="formControl"> </lhpe-input>
  </div>

  <div class="buttons">
    <button mat-button color="fiord" [mat-dialog-close]>Cancel</button>
    <button
      mat-button
      color="lightGreen"
      [mat-dialog-close]="true"
      [disabled]="formControl.invalid"
    >
      Save
    </button>
  </div>
</div>
